import React from "react";
import "./JobSummary.css";
import { _figure_format } from "../../utils";

const JobSummary = ({ firstKey, per, amount }) => {
  return (
    <div className="jobs-diagram">
      <p>{firstKey}</p>
      <div className="broad">
        <div className="apply" style={{ width: per ? `${per}%` : "0%" }} />
      </div>

      <div className="below-apply">
        <div className="each-apply">
          <p>Amount</p>
          <div className="icon-apply">
            &#8358;
            <p>{_figure_format(Number(amount ?? 0))}</p>
          </div>
        </div>

        {/* <div className="each-apply">
          <p>Views</p>
          <div className="icon-apply">
            <ViewsIcon />
            <p>400</p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default JobSummary;
